const isEqual = require('lodash.isequal');

export function isEmpty(obj): boolean {
  if (obj === null || obj === undefined) {
    return true;
  }

  if (Array.isArray(obj)) {
    return obj.length === 0;
  }

  if (typeof obj === 'string' && (obj.length === 0 || !obj.trim())) {
    return true;
  }

  if (typeof obj === 'object') {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }

    return true;
  }

  // Primitives are not empty.
  return false;
}

/**
 * Returns true if the passed value is a JavaScript Date object, false otherwise.
 *
 * @param {Object} value The object to test
 * @return {Boolean}
 */
export function isDate(value: any): boolean {
  return toString.call(value) === '[object Date]';
}

/**
 * Validates that a value is numeric.
 *
 * @param {Object} value Examples: 1, '1', '2.34'
 * @return {Boolean} True if numeric, false otherwise
 */
export function isNumeric(value: any): boolean {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

export function areArraysEqual<T>(oldArray: Array<T>, newArray: Array<T>, compareFn?: (a: T, b: T) => number): boolean {
  // Just an optimization.
  if (oldArray.length !== newArray.length) {
    return false;
  }

  oldArray.sort(compareFn);
  newArray.sort(compareFn);

  return isEqual(oldArray, newArray);
}

/**
 * Method used to prevent csv formula injection
 * https://owasp.org/www-community/attacks/CSV_Injection
 *
 * @return string
 * @param value
 */
export function preventCsvFormulaInjection(value: string): string {
  if (!value) {
    return value;
  }

  const shouldProcessString =
    value.startsWith('=') ||
    value.startsWith('+') ||
    value.startsWith('-') ||
    value.startsWith('@') ||
    value.startsWith('"') ||
    value.startsWith('\t') ||
    value.startsWith('\r');

  if (!shouldProcessString) return value;

  // first prepend each cell field with a single quote
  let parsedString = "'" + value;
  // Escape every double quote using an additional double quote
  parsedString = parsedString.replace(/"/g, '""');
  // Wrap each cell field in double quotes
  return `"${parsedString}"`;
}
